import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadMinors } from "./loadData";
import { MinorHeaders } from "./tableHeaders";

const Minors = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [minors, setMinors] = useState([]);
  const [opened, setOpened] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [viewModalState, setViewModalState] = useState(false);

  useEffect(() => {
    loadMinors(setLoading).then(setMinors);
  }, [location.pathname]);

  const [allIndustryTypes, setAllIndustryTypes] = useState([]);
  useEffect(() => {
    loadMinors(setLoading).then(setAllIndustryTypes);
  }, [location.pathname]);

  return (
    <AdminPage title="Minors">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Major's Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.lookupName}
            description={viewModalData?.lookupType}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={MinorHeaders}
          rowData={minors}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          opened={opened}
          setOpened={setOpened}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Minors);
